import { Divider } from "antd";
import { FC } from "react";
import { Order, OrderItem } from "../../entities/interfaces/order";
import { OrderItems } from "../../hooks/useOrderItem";

type Props = {
  items: OrderItems;
  subtotal: number;
  tax: number;
  total: number;
  membershipDiscount?: number;
};

type OrderItemProps = {
  name: string;
  amount: number;
};

const OrderItemCard: FC<OrderItemProps> = ({ name, amount }) => {
  return (
    <div className="flex justify-between">
      <p className="capitalize">{name}</p>
      <p>₹{amount}</p>
    </div>
  );
};

const OrderSummary: FC<Props> = ({
  subtotal,
  tax,
  total,
  items,
  membershipDiscount,
}) => {
  const renderOrderItems = (items: OrderItems) => {
    return (
      <>
        {items.map((item) => (
          <OrderItemCard
            name={item?.type.toLowerCase().replace("_", " ")}
            amount={item?.amount}
          />
        ))}
        {items.length > 0 && <Divider />}
      </>
    );
  };

  return (
    <div className="p-6 bg-gray-100/80 rounded-xl">
      {/* <h1 className="text-lg font-semibold mb-4">Order Summary</h1> */}
      <div className="flex justify-between font-bold text-xl">
        <p>Total</p>
        <p>₹{total}</p>
      </div>
      <Divider />
      <div className="flex flex-col">{renderOrderItems(items)}</div>
      <div className="flex flex-col gap-3">
        <div className="flex justify-between">
          <p>Sub Total</p>
          <p>₹{subtotal}</p>
        </div>

        {membershipDiscount ? (
          <div className="flex justify-between">
            <p>Membership Discount</p>
            <p>- ₹{membershipDiscount}</p>
          </div>
        ) : (
          <></>
        )}

        <div className="flex justify-between">
          <p>Tax</p>
          <p>₹{tax}</p>
        </div>
      </div>
    </div>
  );
};

export default OrderSummary;
